import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import smoothscroll from 'smoothscroll-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Favicon from 'react-favicon';
import { APP_ENV } from 'appenv';
import polyu618Favicon from 'assets/favicon-polyu618.ico';
import hkstop608Favicon from 'assets/favicon-hkstp608.ico';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import './index.css';
import AppRouter from 'routes/AppRouter';
import { UserSessionContextStateProvider } from 'components/UserSession';
import { EventDatetimeContextStateProvider } from 'components/EventDatetime';
import rootReducer from 'models';
import RongCloudChat from './components/RongCloudChat';
import { BookmarksContextStateProvider } from './components/modals/bookmarks/Bookmarks';

smoothscroll.polyfill();

const store = configureStore({
  reducer: rootReducer,
});

const faviconUrl = () => {
  switch (APP_ENV) {
    case 'hkstp608_production':
    case 'hkstp608_staging':
      return hkstop608Favicon;
    case 'polyu618_staging':
    case 'polyu618_production':
      return polyu618Favicon;
    default:
      return null;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <>
      <Favicon url={faviconUrl()} />
      <Provider store={store}>
        <EventDatetimeContextStateProvider>
          <UserSessionContextStateProvider>
            <BookmarksContextStateProvider>
              <RongCloudChat>
                <AppRouter />
              </RongCloudChat>
            </BookmarksContextStateProvider>
          </UserSessionContextStateProvider>
        </EventDatetimeContextStateProvider>
      </Provider>
    </>,
    document.getElementById('root'),
  );
});
